export const mapPrescriberPersonalInfo = (response) => {
    return response.value.resultItems;
};
export const mapDrugBrandCodesDropdownInfo = (response) => {
    return response.value;
};
export const mapAllPrescriberInfo = (response) => {
    return response.value;
};
